import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HeaderMenuConfig, DEFAULT_HEADER_MENU_CONFIG, saveHeaderMenuConfig } from 'src/app/utils/header-menu-config.util';

@Injectable({
  providedIn: 'root'
})
export class SiteConfigService {
  constructor(private http: HttpClient) {}

  getSiteConfig(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/site-config`).pipe(
      tap((res: any) => {
        if (res?.headerMenuConfig) {
          saveHeaderMenuConfig(res.headerMenuConfig);
        }
        if (Array.isArray(res?.blockedTroupeMemberAdditionIds)) {
          localStorage.setItem('ctms_blocked_member_addition_troupes', JSON.stringify(res.blockedTroupeMemberAdditionIds));
        }
      }),
      catchError(() => of({ headerMenuConfig: DEFAULT_HEADER_MENU_CONFIG, blockedTroupeMemberAdditionIds: [] }))
    );
  }

  updateSiteConfig(payload: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/site-config`, payload).pipe(
      tap((res: any) => {
        if (res?.config?.headerMenuConfig) {
          saveHeaderMenuConfig(res.config.headerMenuConfig);
        }
        if (Array.isArray(res?.config?.blockedTroupeMemberAdditionIds)) {
          localStorage.setItem('ctms_blocked_member_addition_troupes', JSON.stringify(res.config.blockedTroupeMemberAdditionIds));
        }
      })
    );
  }

  toggleTroupeMemberBlock(troupeId: number, block?: boolean): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/site-config/toggle-troupe-block`, { troupeId, block }).pipe(
      tap((res: any) => {
        if (res?.success) {
          if (Array.isArray(res?.blockedTroupeMemberAdditionIds)) {
            localStorage.setItem('ctms_blocked_member_addition_troupes', JSON.stringify(res.blockedTroupeMemberAdditionIds));
          }
          if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('troupeMemberBlockChange', { detail: { troupeId, isBlocked: res.isBlocked } }));
          }
        }
      })
    );
  }
}
